import React, { useEffect, useState, createContext } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getHDFConfiguration } from "./actions";
import HDFStepper from "./components/Stepper";
import { Loader } from "cxa-components";
import Form from "./Form";
import FooterPP from "../../common/FooterPP";
import Header from "./Header";
import { Prompt } from "react-router-dom";
import messages from "components/messagesDescription";
import { injectIntl } from "react-intl";
export const HdfDataContext = createContext();

const GenHDF = ({
  match: {
    params: { hdfId, planYearId, enrolmentKey },
  },
  intl,
  ...props
}) => {
  const dispatch = useDispatch();

  const [activePage, setActivePage] = useState(1);
  const genHDF = useSelector(state => state.genHDF);
  const pages = (genHDF.hdfData && genHDF.hdfData.config && genHDF.hdfData.config.pages) || [];
  useEffect(() => {
    dispatch(getHDFConfiguration(hdfId));
  }, []);

  useEffect(() => {
    // Handle browser/tab close event
    const handleBeforeUnload = (e) => {
      const hdfData = genHDF.hdfData || {};

      if (!hdfData.isCompleted) {
        // Standard way to show a confirmation dialog when closing the browser/tab
        e.preventDefault();
        e.returnValue = intl.formatMessage({ ...messages.unSaveGenHDFMessage });
        return intl.formatMessage({ ...messages.unSaveGenHDFMessage });
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [genHDF, intl]);

  return genHDF.isFetching || pages.length <= 0 ? (
    <Loader />
  ) : (
    <HdfDataContext.Provider value={genHDF.hdfData}>
      <Header header={genHDF.hdfData.config.header} />
      <div className="main">
        <div className="main-container hdf-wrapper">
          <HDFStepper steps={pages} index={activePage} />
          <Form
            data={genHDF.hdfData}
            activePage={activePage}
            isLastPage={activePage === pages.length}
            initialValues={genHDF.initialValues}
            setActivePage={setActivePage}
            intl={intl}
            {...props}
          />
        </div>
      </div>
      <Prompt
        when={!genHDF.hdfData.isCompleted}
        message={() => intl.formatMessage({ ...messages.unSaveGenHDFMessage })}
      />
      <FooterPP hideLanguageSelector={true} />
    </HdfDataContext.Provider>
  );
};

GenHDF.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      hdfId: PropTypes.string,
      planYearId: PropTypes.string,
      enrolmentKey: PropTypes.string,
    }),
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};
export default injectIntl(GenHDF);



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/index.js